export const selectAuth = state => state.auth;
